module.exports = __webpack_public_path__ + "static/img/news2.5199c9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/news2.png
// module id = NwJF
// module chunks = 7